import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';
import { checkChanges } from '../../../utils/checkChanges';

import Edit from './Edit';

export default class Project extends Component {
  static propTypes = {
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
    children: PropTypes.node,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object,
    }),
  }
  static contextTypes = {
    store: PropTypes.object,
  }

  static Edit = checkChanges(Edit)

  renderChild() {
    return Children.map(this.props.children, child => (
      React.cloneElement(child, {
        params: this.props.params,
        location: this.props.location,
      })
    ));
  }
  render() {
    return (
      <div>
        {this.renderChild()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Project/MultiUnits/MultiUnits.jsx